import React from "react";
import { Navbar } from "react-bootstrap";
import styled from "styled-components";

import logoImg from "../../../images/logo/v.png";

const NavbarCont = styled(Navbar)`
  position: fixed;
  top: -50px;
  left: 0;
  right: 0;
  background: #000;
  z-index: 1000;
  height: auto;
  padding: 120px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border-bottom: ${(props) =>
    props.$hasQuizHeader ? "1px solid rgba(255, 255, 255, 0.1)" : "none"};
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${(props) => (props.$hasQuizHeader ? "5px" : "0")};
`;

const QuizHeaderContainer = styled.div`
  width: 100%;
  padding-bottom: 0px;
`;

function NavbarQuizComp({ quizHeader }) {
  return (
    <NavbarCont $hasQuizHeader={!!quizHeader}>
      <LogoContainer $hasQuizHeader={!!quizHeader}>
        <img src={logoImg} alt="Vibe Check Logo" style={{ height: "40px" }} />
      </LogoContainer>
      {quizHeader && <QuizHeaderContainer>{quizHeader}</QuizHeaderContainer>}
    </NavbarCont>
  );
}

export default NavbarQuizComp;
